var image_viewer_rtlignore_default = {
  "fontElementMap": "Vwt1L",
  "imageContainer": "rvd09",
  "expandButton": "WWtdr",
  "expandIcon": "UXJ4r",
  "pointer": "G-M85",
  "imageWrapper": "jNYkX",
  "imageRatio": "_6wKDI",
  "image": "T9iiE",
  "imageOverlay": "jIhsV",
  "imagePreload": "jZLA6",
  "imageHighres": "ehh8K",
  "onlyHighRes": "N8XhT",
  "image_loading": "uGFvM"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
